import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as yup from 'yup';
import { Formik } from 'formik';
import Typography from '@mui/material/Typography';
import { closePopup } from '../../actions/uiActions'
import { changePassword } from '../../actions/userActions'
import CloseIcon from '@mui/icons-material/Close';

class ChangePassword extends React.Component {

    state = {
        previousPW: "",
        newPW: "",
        confirmNewPW: "",
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        console.log(this.props.userID, this.props.email, this.state.previousPW, this.state.newPW, this.state.confirmNewPW)
        this.props.changePassword(this.props.userID, this.props.email, this.state.previousPW, this.state.newPW, this.state.confirmNewPW)
    }

    changeText = (event, str) => {
        event.preventDefault()
        this.setState({ [str]: event.target.value })
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Change your Password
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Formik
                            initialValues={{
                                oldpassword: '',
                                newpassword: '',
                                confirmpassword: ''
                            }}
                            validationSchema={yup.object().shape({
                                oldpassword: yup.string().required('Requird'),
                                newpassword: yup
                                    .string()
                                    .required('Required')
                                    .matches(
                                        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
                                        'Must Contain 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character'
                                    ),
                                confirmpassword: yup
                                    .string()
                                    .required('Requird')
                                    .equals([yup.ref('newpassword')], "password don't match")
                            })}
                        >
                            {({
                                values,
                                handleChange,
                                errors,
                                setFieldTouched,
                                touched
                            }) => (
                                <form>
                                    <div className="requiredPass">
                                        <p>Passwords must be at least 6 characters</p>
                                        <p>Passwords must have at least one lowercase ('a'-'z')</p>
                                        <p>Passwords must have at least one uppercase ('A'-'Z')</p>
                                        <p>Passwords must have at least one digit ('0'-'9')</p>
                                        <p>
                                            Passwords must have at least one non alphanumeric
                                            character
                                        </p>
                                    </div>
                                    <div className="passwordResetbox">
                                        <input
                                            type="text"
                                            placeholder="Existing Password"
                                            className="myInput"
                                            value={values.oldpassword}
                                            onChange={handleChange('oldpassword')}
                                            onBlur={() => setFieldTouched('oldpassword')}
                                            onChangeCapture={(event) => this.changeText(event, "previousPW")}
                                        />
                                        {errors.oldpassword && touched.oldpassword && (
                                            <Typography className="loginError">
                                                {errors.oldpassword}
                                            </Typography>
                                        )}
                                        <input
                                            type="text"
                                            placeholder="New Password"
                                            className="myInput"
                                            value={values.newpassword}
                                            onChange={handleChange('newpassword')}
                                            onBlur={() => setFieldTouched('newpassword')}
                                            onChangeCapture={(event) => this.changeText(event, "newPW")}
                                        />
                                        {errors.newpassword && touched.newpassword && (
                                            <Typography className="loginError">
                                                {errors.newpassword}
                                            </Typography>
                                        )}
                                        <input
                                            type="text"
                                            placeholder="Confirm Password"
                                            className="myInput"
                                            value={values.confirmpassword}
                                            onChange={handleChange('confirmpassword')}
                                            onBlur={() => setFieldTouched('confirmpassword')}
                                            onChangeCapture={(event) => this.changeText(event, "confirmNewPW")}
                                        />
                                        {errors.confirmpassword && touched.confirmpassword && (
                                            <Typography className="loginError">
                                                {errors.confirmpassword}
                                            </Typography>
                                        )}
                                        <button
                                            type="submit"
                                            className="btn"
                                            onClick={(e) => this.handleSubmit(e)}
                                        >
                                            Submit
                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

        )
    }
}

function mapStateToProps(state) {
    return {
        userID: state.users.userID,
        email: state.users.email,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, changePassword }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)